import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

export type TColumnHeading = {
  value: string;
  action?: Function;
  sortValue?: string | number;
};

@Component({
  selector: "app-table-view",
  template: `
    <span
      style="color: var(--schcol, #c5c5c5); font-weight: 500 !important; display: block; text-align: center"
      *ngIf="tableName"
      >{{ tableName }}</span
    >
    <div class="table-responsive tableToDisplayData">
      <table
        class="table search"
        #table
        matSort
        (matSortChange)="sortFunction($event)"
      >
        <thead [id]="tableId">
          <tr>
            <th
              *ngFor="let columnTitle of columnTitles"
              (click)="columnTitle.action()"
              style="text-align: center; cursor: {{
                columnTitle?.action ? 'pointer' : 'initial'
              }};"
              [attr.mat-sort-header]="columnTitle?.sortValue"
              [innerHtml]="sanitizer.bypassSecurityTrustHtml(columnTitle.value)"
            >
              <!-- <i class='fa fa-lock'></i> -->
            </th>
          </tr>
        </thead>
        <!-- <tbody> -->
        <ng-content></ng-content>
        <!-- </tbody> -->
      </table>
    </div>
  `,
  styleUrls: ["./table-view.component.scss"],
})
export class TableViewComponent implements OnInit {
  @Input("table-name") tableName: string | undefined = undefined;
  @Input("id") tableId = ""; // the html table Id;
  @Input() columnTitles: TColumnHeading[] = []; // the array for the column headings;
  @Input() sortFunction: Function | undefined = undefined; // a sort function for the table;
  constructor(public sanitizer: DomSanitizer) {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/common/table-view/table-view.component.ts